import React from 'react';
import Chart from './Chart';

export default function StackedPercentageBarChart(props) {

  const stackedPercentageBarOption = {
    chart: {
      type: 'column'
    },
    yAxis: {
      min: 0,
      title: {
        text: ''
      },
      reversedStacks: false
    },
    tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
    },
    plotOptions: {
      column: {
        stacking: 'percent'
      }
    },
  }

  function serieOption(data) {
    return {
      ...stackedPercentageBarOption,
      series: data.series,
      xAxis: {
        categories: data.categories
      }
    }
  }

  return (
    <Chart
      options={serieOption(props.data)}
      legendOptions={props.legendOptions}
    />
  )
}
